<input (keyup)="addPill($event.keyCode, tagsInput.value)" type="text" [placeholder]="'Añadir '+placesHolder+'...'" class="my-05" #tagsInput>
<div class="flex-box js-left">
    <div *ngFor="let pill of pills, let i=index" class="pill">
        {{ pill }}
        <div (click)="deletePill(i)" class="d-flex"></div>
    </div>
</div>